import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
    <ToastContainer />
  </React.StrictMode>
);

// Tear down any previously-registered service worker and its caches. The old
// SW was intercepting index.html / bundle.js for returning users and pinning
// them to stale builds across deploys. Keep this in place for at least one
// release cycle so existing clients self-heal on next load.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .catch(() => {});
  if (typeof caches !== 'undefined') {
    caches.keys()
      .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
      .catch(() => {});
  }
}

// Enhanced web vitals reporting for performance monitoring
reportWebVitals((metric) => {
  // Send to analytics in production
  if (process.env.NODE_ENV === 'production') {
    console.log('Web Vital:', metric);
    // TODO: Send to analytics service
    // analytics.track('Web Vital', metric);
  }
});

// Performance observer for monitoring
if ('PerformanceObserver' in window) {
  const observer = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      if (entry.entryType === 'navigation') {
        const navEntry = entry as PerformanceNavigationTiming;
        console.log('Navigation timing:', {
          domContentLoaded: navEntry.domContentLoadedEventEnd - navEntry.domContentLoadedEventStart,
          loadComplete: navEntry.loadEventEnd - navEntry.loadEventStart,
          total: navEntry.loadEventEnd - navEntry.fetchStart
        });
      }
    });
  });
  
  observer.observe({ entryTypes: ['navigation'] });
}
